import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_VENDOR_RELATION, GET_DISCOUNT_GROUP_VENDOR_RELATION, GET_DISCOUNT_GROUP_VENDOR_RELATIONS, SAVE_DISCOUNT_GROUP_VENDOR_RELATION } from "../../../data/definitions/discount-group-vendor-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupVendorRelationMutation, DeleteDiscountGroupVendorRelationMutationVariables, DeletionResponse, DiscountGroupVendorRelation, DiscountGroupVendorRelationInput, DiscountGroupVendorRelationSearchInput, GetDiscountGroupVendorRelationQuery, GetDiscountGroupVendorRelationQueryVariables, GetDiscountGroupVendorRelationsQuery, GetDiscountGroupVendorRelationsQueryVariables, SaveDiscountGroupVendorRelationMutation, SaveDiscountGroupVendorRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupVendorRelationService extends BaseListService<DiscountGroupVendorRelation> implements ICRUD<DiscountGroupVendorRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupVendorRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupVendorRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupVendorRelationSearchInput): QueryResult<GetDiscountGroupVendorRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_VENDOR_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupVendorRelationsQuery, GetDiscountGroupVendorRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupVendorRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupVendorRelationQuery, GetDiscountGroupVendorRelationQueryVariables>(
            GET_DISCOUNT_GROUP_VENDOR_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupVendorRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupVendorRelation as DiscountGroupVendorRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupVendorRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupVendorRelation as DiscountGroupVendorRelation);
    }

    async saveItem(item: DiscountGroupVendorRelationInput): Promise<DiscountGroupVendorRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.VENDOR;

        let validated = await this.systemService.validateObject<DiscountGroupVendorRelationInput>(item, "DiscountGroupVendorRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupVendorRelationMutation, SaveDiscountGroupVendorRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_VENDOR_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupVendorRelation as DiscountGroupVendorRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupVendorRelationMutation, DeleteDiscountGroupVendorRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_VENDOR_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupVendorRelation;
    }
}